import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';

export const GlobalIssueCategoryBasicInfoComponent = ({
  parentIssueCategoriesList,
  globalDbnTaxonomyDomainList,
  handleInnerFormChange,
  selectedIssueCategories,
}: any) => {

  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Platform"
              labelField="Name"
              list={globalDbnTaxonomyDomainList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Platform'
                );
              }}
              optionName="Choose Platform Name"
              type="select"
              value={selectedIssueCategories?.Platform}
              valueField="Name"
            />

            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',
                )
              }}
              type="text"
              value={selectedIssueCategories?.Name}
            />

            <InputContainer
              label="Sub Issue Category"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsSubIssueCategory',
                )
              }}
              type="checkbox"
              value={selectedIssueCategories?.IsSubIssueCategory}
            />

            {selectedIssueCategories?.IsSubIssueCategory === true &&
              <InputContainer
                label="Parent Issue Category"
                labelField="Name"
                list={parentIssueCategoriesList}
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'ParentIssueCategoryId'
                  );
                }}
                optionName="Choose Parent Category"
                type="select"
                value={selectedIssueCategories?.ParentIssueCategoryId}
                valueField="GlobalIssueCategoryId"
              />
            }
            <InputContainer
              label="Display Order"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DisplayOrder'
                );
              }}
              type="number"
              value={selectedIssueCategories?.DisplayOrder}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}